import { useCallback, useState } from 'react';
import _debounce from 'lodash/debounce';

type Props = {
  initialValue?: string;
  timeout?: number;
};
export function useDebouncedInput({ initialValue = '', timeout = 300 }: Props) {
  const [inpValue, setInpValue] = useState(initialValue);
  const [debValue, setDebValue] = useState(initialValue);

  const handleDebounce = useCallback(
    _debounce((text) => {
      setDebValue(text);
    }, timeout),
    [],
  );

  const setInputValue = (value: string) => {
    setInpValue(value);
    handleDebounce(value);
  };

  const clearInput = () => {
    setInpValue('');
    setDebValue('');
    handleDebounce.cancel();
  };

  return {
    setInputValue,
    inputValue: inpValue,
    debouncedValue: debValue,
    clearInput,
  };
}
